export default __webpack_public_path__ + "static/solution-retailer.url-9ff47cf8d56a74f43eb722995bd61ac8.svg";